import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const SiteContext = createContext();
export const useSite = () => useContext(SiteContext);
const SiteProvider = ({ children, initLocale = "NL", defaultLocale = "NL", pages = [], forms = [], menus = [], repeatables = [], activePage, languages = [], textPlaceholders = null, repeatableItem = null, }) => {
    const [locale, setLocale] = useState(initLocale);
    return (_jsx(SiteContext.Provider, { value: {
            children,
            locale,
            setLocale,
            pages,
            forms,
            menus,
            activePage,
            languages,
            defaultLocale,
            textPlaceholders,
            repeatables,
            repeatableItem,
        }, children: children }));
};
export default SiteProvider;
//# sourceMappingURL=SiteProvider.js.map